var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8137 1.00012L14.4353 7.95791L16.1771 3.85298L23.8137 1.00012Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18628 1.00024L11.4794 8.02388L9.82296 3.8531L2.18628 1.00024Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4421 17.1289L17.9473 20.9519L23.2857 22.4201L24.8114 17.2133L20.4421 17.1289Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19751 17.2129L2.7139 22.4197L8.05234 20.9515L5.56676 17.1285L1.19751 17.2129Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75978 10.6693L6.27222 12.9201L11.564 13.1557L11.385 7.45862L7.75978 10.6693Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2395 10.6692L14.5577 7.3927L14.4353 13.1556L19.7271 12.9201L18.2395 10.6692Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.052 20.952L11.2446 19.3975L8.49445 17.2511L8.052 20.952Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7554 19.3975L17.948 20.952L17.5056 17.2511L14.7554 19.3975Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.948 20.9517L14.7554 19.3971L15.0095 21.4785L14.9817 22.3541L17.948 20.9517Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05176 20.9516L11.0181 22.354L10.9995 21.4784L11.2444 19.397L8.05176 20.9516Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0748 15.8761L8.41919 15.0951L10.2928 14.238L11.0748 15.8761Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9248 15.8759L15.7067 14.2378L17.5897 15.0949L14.9248 15.8759Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05225 20.9519L8.51324 17.1285L5.56641 17.2129L8.05225 20.9519Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4866 17.1285L17.9476 20.9519L20.4427 17.2129L17.4866 17.1285Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7918 12.1289L14.5 12.3645L14.9897 15.0846L15.7715 13.4468L17.6541 14.3037L19.7918 12.1289Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64695 14.3037L10.5203 13.4468L11.3021 15.0846L11.7918 12.3645L6.5 12.1289L8.64695 14.3037Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27222 12.92L8.49429 17.251L8.41917 15.0948L6.27222 12.92Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5895 15.0948L17.5051 17.251L19.7272 12.92L17.5895 15.0948Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5641 13.1556L11.0745 15.8757L11.6958 19.0864L11.8275 14.8593L11.5641 13.1556Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4353 13.1555L14.1812 14.8499L14.3036 19.0863L14.9249 15.8756L14.4353 13.1555Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9251 15.8757L14.3037 19.0864L14.7554 19.3971L17.5051 17.2511L17.5895 15.0948L14.9251 15.8757Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41919 15.0948L8.49431 17.2511L11.2441 19.3971L11.6957 19.0864L11.0744 15.8757L8.41919 15.0948Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9817 22.3537L15.0095 21.4782L14.7749 21.2714H11.2246L10.9992 21.4782L11.0178 22.3537L8.05176 20.9514L9.08773 21.7982L11.1968 23.258H14.8027L16.9118 21.7982L17.9477 20.9514L14.9817 22.3537Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7555 19.3971L14.3039 19.0864H11.696L11.2443 19.3971L10.9995 21.4782L11.2249 21.2714H14.775L15.0096 21.4782L14.7555 19.3971Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2089 8.41026L25.0001 4.56873L23.8138 0.999878L14.7554 7.72301L18.2398 10.6695L23.1637 12.1108L24.247 10.8393L23.7758 10.5007L24.5289 9.81258L23.9548 9.3609L24.7079 8.78681L24.2089 8.41026Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5691L1.8004 8.41063L1.29215 8.78717L2.04524 9.36127L1.47115 9.81294L2.22424 10.5011L1.7531 10.8396L2.83636 12.1112L7.76023 10.6699L11.2447 7.72338L2.18622 1.00024L1 4.5691Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1635 12.1106L18.2397 10.6693L19.7273 12.9203L17.5051 17.2515L20.4424 17.2134H24.8116L23.1635 12.1106Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76044 10.6694L2.83657 12.1107L1.19775 17.2136H5.567L8.49499 17.2516L6.2728 12.9204L7.76044 10.6694Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4352 13.1556L14.7552 7.72286L16.1769 3.85278H9.82227L11.244 7.72286L11.5639 13.1556L11.6864 14.8685L11.6956 19.0864H14.3035L14.3128 14.8685L14.4352 13.1556Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/MetamaskIcon.042d0d7a539329e5e987550303da930a.svg";
export { ForwardRef as ReactComponent };